import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from '../../utils/auth'

export default (store) => ({
  path: 'product-analytics',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const ProductSalesAnalyticsContainer = require('./containers/ProductSalesAnalytics').default;
      const reducer = require('./modules/productSalesAnalytics').reducer;
      let homeReducers = require('../Home/modules/home');

      /*  Add the reducer to the store on key 'counter'  */
      const loadStoreOptionsReducer = homeReducers.loadStoreOptionsReducer;
      const filterValuesReducer = homeReducers.filterValuesReducer;
      injectReducer(store, {key: 'productSalesAnalytics', reducer: reducer});
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer});
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer});
      /*  Return getComponent   */
      cb(null, ProductSalesAnalyticsContainer)

      /* Webpack named bundle   */
    }, 'productSalesAnalytics')
  }
})



// WEBPACK FOOTER //
// ./src/routes/ProductSalesAnalytics/index.js